export enum NotificationType {
  Decline = 'decline',
  Approval = 'approval',
  AccountReopened = 'account-reopened',
  AccountPermanentlyClosed = 'account-permanently-closed',
  Locked = 'locked',
  TooManyCancelledApplications = 'too-many-cancelled-applications',
  ReviewWithEmail = 'review-with-email',
  ReviewUniversal = 'review-universal',
  Canceled = 'canceled',
  UnderMaintenance = 'under-maintenance',
  ProcessingTimeout = 'processing-timeout',
  SessionExpired = 'session-expired',
  OfferCodeExpired = 'offer-code-expired',
  OfferCodeUsed = 'offer-code-used',
}
